import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77fb7839"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fb7839')) {
      api.createRecord('77fb7839', component.options)
    } else {
      api.reload('77fb7839', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77fb7839", function () {
      api.rerender('77fb7839', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/bank/index.vue"
export default component.exports